import { render, staticRenderFns } from "./OrderCardBasicData.vue?vue&type=template&id=710dddee&scoped=true"
import script from "./OrderCardBasicData.vue?vue&type=script&lang=ts"
export * from "./OrderCardBasicData.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "710dddee",
  null
  
)

export default component.exports